import React from 'react';
import {useQuery} from '@apollo/client';
import Back from '../../components/Back';
import Query from '../../components/Query';
import {QUERY_DOC_DETAIL} from './graphql';

const DocDetail = ({match}) => {
  const query = useQuery(QUERY_DOC_DETAIL, {variables: {id: match.params.id}});
  const obj = query.data ? query.data.docDetail : null;

  return (
    <div className="container py-4">
      <div className="mb-4">
        <Back />
      </div>
      {Query(query) || (
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="mb-4 font-4">{obj.name}</div>
            <div className="mb-4 bg-white border rounded p-3" dangerouslySetInnerHTML={{__html: obj.content}} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DocDetail;
